'use client';

import { LoadingOutlined } from '@ant-design/icons';
import {
    FetchNextPageOptions,
    InfiniteData,
    InfiniteQueryObserverResult,
} from '@tanstack/react-query';
import React, { useEffect } from 'react';

import { useInView } from 'react-intersection-observer';
// import LoadingSpinner from './ui/loading-spinner';

type TInfiniteLoaderProps = {
    children: React.ReactNode;
    hasNextPage: boolean;
    isFetchingNextPage: boolean;
    fetchNextPage: (
        options?: FetchNextPageOptions
    ) =>
        | Promise<
              InfiniteQueryObserverResult<InfiniteData<any, unknown>, Error>
          >
        | Promise<InfiniteQueryObserverResult<any[], Error>>;
};
const InfiniteLoaderWrapper = (props: TInfiniteLoaderProps) => {
    const { children, hasNextPage, fetchNextPage, isFetchingNextPage } = props;

    const { ref, inView } = useInView();

    useEffect(() => {
        if (inView && hasNextPage) fetchNextPage();
    }, [hasNextPage, inView, fetchNextPage]);

    return (
        <>
            {children}
            <div ref={ref}></div>
            {isFetchingNextPage && (
                <>
                    {/* <div className="min-h-[100px] py-[24px] flex items-center justify-center">
                   <LoadingSpinner className="w-[35px] h-[35px]" />
                 </div> */}
                    <div>
                        <LoadingOutlined />
                    </div>
                </>
            )}
        </>
    );
};

export default InfiniteLoaderWrapper;
